export const DATE_VIEW_PATTERN = 'dd.MM.yyyy hh:mm';
export const DATE_REQUEST_PATTERN = 'yyyy-MM-dd';

export const MONTH_KEYS = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
] as const;
